'use es6';

import PropTypes from 'prop-types';
import unescapedText from 'I18n/utils/unescapedText';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MenuEmptyState = ({
  addNode,
  readOnly
}) => {
  return /*#__PURE__*/_jsx(EmptyState, {
    "data-test-id": "menus-empty-state",
    marginBlockStart: 1200,
    layout: "vertical",
    reverseOrder: true,
    titleText: unescapedText('simpleMenusLib.emptyState.header'),
    primaryContent: /*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsx(Text, {
        children: unescapedText('simpleMenusLib.emptyState.body')
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "add-menu-item-simple",
        marginBlockStart: "600",
        disabled: readOnly,
        onClick: addNode,
        use: "primary",
        children: unescapedText('simpleMenusLib.emptyState.button')
      })]
    }),
    secondaryContent: /*#__PURE__*/_jsx(Illustration, {
      name: "empty-state-charts",
      width: "100%"
    }),
    secondaryContentWidth: 150
  });
};
MenuEmptyState.propTypes = {
  addNode: PropTypes.func.isRequired,
  readOnly: PropTypes.bool
};
export default MenuEmptyState;